import { apiAxiosCMS } from 'services/api';
import { MenuItemLocationProps } from 'types/MenuItemLocationProps';

export async function getItensMenu(
	setListItens: React.Dispatch<React.SetStateAction<MenuItemLocationProps[]>>,
	handleNotify: any
) {
	await apiAxiosCMS
		.get(`menu-items-location/`)
		.then((res) => {
			if (res.data.length > 0) {
				setListItens(res?.data || []);
			}
		})
		.catch((error) => {
			handleNotify(error.message || 'Erro ao buscar os itens de menu', 'error');
		});
}
